import i18next from 'i18next';

export const taxreturnTypesCollection = () => [
  {
    id: 'original',
    name: i18next.t('common.taxreturn-types.original')
  },
  {
    id: 'amending',
    name: i18next.t('common.taxreturn-types.amending')
  }
];
